import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
  INVOICE_WOI_STATE,

  INVOICE_WOI_CREATE, INVOICE_WOI_EINVOICE_CREATE, INVOICE_WOI_LIST, INVOICE_WOI_NUMBER, INVOICE_WOI_SINGLE,
  INVOICE_WOI_UPDATE, INVOICE_WOI_DELETE, INVOICE_WOI_SEND,

  CLEAR_INVOICE_TEMP_STATES, CLEAR_INVOICE_STATES, INVOICE_NUMBER, CLEAR_INVOICE_TEMP_SENT
} from '../../../../Helper/actionsTypes';

const iState = {
  woi_state: {
    dropName: ' Amt ',
    local: true,
    isCustomer: true,
    isShipping: false,
    dropdownOpen: false,
    isSameAddress: false,
    roundOff: 0,
    customer: {
      name: '',
      person: '',
      contNum: '',
      gstin: '',
      address: '',
      state: '',
      code: ''
    }
  }
}


const invoiceReducer = (state = iState, action) => {
  switch (action.type) {
    case INVOICE_WOI_STATE: {
      return { ...state, woi_state: action.payload };
    }
    // case 'LOCAL_STATE' :{
    //   return {...state, woi_state:woi_state}
    // }
    case INVOICE_WOI_LIST: {
      return action.payload?.code === 200
        ? { ...state, woi_list: action.payload.results }
        : { ...state, woi_list: [] };
    }
    case INVOICE_WOI_SEND: {
      return action.payload?.code === 200
        ? { ...state, sent: true, message: action.payload.message }
        : { ...state, sent: false, message: action.payload?.message };
    }
    // case INVOICE_WOI_NUMBER:{
    //   return action.error
    //     ? {...state, woi_number: null}
    //     : {...state, woi_number: action.payload};
    // }
    case INVOICE_NUMBER: {
      return action.payload?.code === 200 ? { ...state, woi_number: action.payload.results.invoice_no ? action.payload.results.invoice_no : action.payload.results.proforma_no, prefix: action.payload.results.prefix } : { ...state, woi_number: null }
    }
    case 'INITIAL_CHECK': {
      return { ...state, woi_state: action.payload }
    }
    case INVOICE_WOI_SINGLE: {
      if (action.payload?.code === 200) return { ...state, woi_single: action.payload.results }
      else if (action.payload?.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else return { ...state, woi_single: {} }
    }
    case INVOICE_WOI_DELETE: {
      if (action.payload?.code === 200) return { ...state, woi_itemDeleted: true, message: action.payload.message }
      else if (action.payload?.code === 500) return { ...state, woi_itemDeleted: false, message: DELMSG }
      else if (action.payload?.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else return { ...state, woi_itemDeleted: false, message: action.payload?.message }
    }
    case INVOICE_WOI_EINVOICE_CREATE:
    case INVOICE_WOI_CREATE: {
      if (action.payload?.code === 200) {
        return {
          ...state,
          woi_itemSaved: true,
          message: action.payload.message,
          woi_einvoice_failed: action.payload.status === false
        };
      }
      else if (action.payload?.code === 500) return { ...state, woi_itemSaved: false, message: CRTMSG }
      else if (action.payload?.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else return { ...state, woi_itemSaved: false, message: action.payload?.message }
    }
    case INVOICE_WOI_UPDATE: {
      if (action.payload?.code === 200) return { ...state, woi_itemUpdated: true, message: action.payload.message }
      else if (action.payload?.code === 500) return { ...state, woi_itemUpdated: false, message: UPTMSG }
      else if (action.payload?.code === 404) return { ...state, badReq: true, message: action.payload.message }
      else return { ...state, woi_itemUpdated: false, message: action.payload?.message }
    }
    case CLEAR_INVOICE_TEMP_STATES:
      return {
        ...state,
        sent: null,
        woi_itemDeleted: null,
        woi_itemSaved: null,
        woi_itemUpdated: null,
        woi_einvoice_failed: null,
        woi_delete: {},
        woi_create: {},
        woi_update: {},
        woi_list: [],
        badReq: null,
        message: null
      };
    case CLEAR_INVOICE_TEMP_SENT:
      return {
        ...state,
        woi_state: {
          dropName: ' Amt ',
          local: true,
          isCustomer: true,
          isShipping: false,
          dropdownOpen: false,
          isSameAddress: false,
          roundOff: 0,
          customer: {
            name: '',
            person: '',
            contNum: '',
            gstin: '',
            address: '',
            state: '',
            code: ''
          }
        },
        sent: null,
        woi_itemDeleted: null,
        woi_itemSaved: null,
        woi_itemUpdated: null,
        woi_einvoice_failed: null,
        woi_delete: {},
        woi_create: {},
        woi_update: {},
        badReq: null,
        message: null
      };
    case CLEAR_INVOICE_STATES: return {
      woi_state: {
        dropName: 'Amt',
        local: true,
        isCustomer: true,
        isShipping: false,
        dropdownOpen: false,
        isSameAddress: false,
        roundOff: 0,
        customer: {
          name: '',
          person: '',
          contNum: '',
          gstin: '',
          address: '',
          state: '',
          code: '',
        }
      }
    };
    default: return state;
  }
};

export default invoiceReducer;